import { ScoutQuery } from '../../services/scout.service'

interface Props {
  query: ScoutQuery
  onEdit: (query: ScoutQuery) => void
  onDelete: (id: number) => void
  onRunNow: (id: number) => void
  onToggle: (id: number, active: boolean) => void
}

export default function ScoutQueryCard({ query, onEdit, onDelete, onRunNow, onToggle }: Props) {
  const keywords = query.target_keywords ? JSON.parse(query.target_keywords) as string[] : []

  return (
    <div className={`bg-white rounded-lg border p-4 ${!query.is_active ? 'opacity-60' : ''}`}>
      <div className="flex items-start justify-between mb-2">
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900 text-lg">{query.query_text}</h3>
          {query.business_context && (
            <p className="text-sm text-gray-500 mt-1 line-clamp-2">{query.business_context}</p>
          )}
        </div>
        <div className="flex items-center gap-2 ml-3">
          <button
            onClick={() => onToggle(query.id, !query.is_active)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              query.is_active ? 'bg-primary-600' : 'bg-gray-300'
            }`}
          >
            <span
              className={`inline-block h-4 w-4 rounded-full bg-white transition-transform ${
                query.is_active ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
        </div>
      </div>

      {keywords.length > 0 && (
        <div className="flex flex-wrap gap-1 mb-3">
          {keywords.map((kw: string, i: number) => (
            <span key={i} className="px-2 py-0.5 bg-blue-50 text-blue-700 text-xs rounded-full">
              {kw}
            </span>
          ))}
        </div>
      )}

      <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
        <span>Каждые {query.schedule_hours}ч</span>
        <span className="px-2 py-0.5 bg-gray-100 rounded-full text-xs">
          {query.search_types === 'channels' ? 'Каналы' : query.search_types === 'groups' ? 'Группы' : 'Все'}
        </span>
        {query.min_subscribers > 0 && <span>Min {query.min_subscribers} подп.</span>}
        <span>
          Последний запуск:{' '}
          {query.last_run_at
            ? new Date(query.last_run_at).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
            : 'Никогда'}
        </span>
        {query.pending_count > 0 && (
          <span className="px-2 py-0.5 bg-amber-100 text-amber-700 rounded-full font-medium">
            {query.pending_count} на ревью
          </span>
        )}
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={() => onRunNow(query.id)}
          disabled={!query.is_active}
          className="px-3 py-1.5 bg-primary-600 text-white text-sm rounded-lg hover:bg-primary-700 disabled:opacity-50"
        >
          Запустить
        </button>
        <button
          onClick={() => onEdit(query)}
          className="px-3 py-1.5 border border-gray-300 text-gray-700 text-sm rounded-lg hover:bg-gray-50"
        >
          Изменить
        </button>
        <button
          onClick={() => onDelete(query.id)}
          className="px-3 py-1.5 text-red-600 text-sm hover:bg-red-50 rounded-lg"
        >
          Удалить
        </button>
      </div>
    </div>
  )
}
